import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import EditIcon from '@mui/icons-material/Edit'
import { XMarkSvg } from '../../../../common/svg/xMark'
import { CheckMarkSvg } from '../../../../common/svg/checkMark'
import { connect } from 'react-redux'
import { updateModal, updateAlertError } from '../../../../../store/common/common_action'
import TicketFormatModal from './TicketFormatModal'
import TicketFormatCreateModal from './TicketFormatCreateModal'
import * as mdt from '../../../../common/modaltypes'
import {
  getBranchesWithCargoTicketFormat,
  getCargoTicketFormatList,
  AssignCargoTicketFormat,
  getTicketLabelList,
  updateTicketFormat,
} from '../../../../../store/generalSetting/GSAction'
const TicketFormat = (props) => {
  const {
    data,
    updateModal,
    updateAlertError,
    getTicketLabelList,
    getBranchesWithCargoTicketFormat,
    getCargoTicketFormatList,
    AssignCargoTicketFormat,
    updateTicketFormat,
  } = props
  const { common, generalSettingReducer } = data
  const { labelList, ticketFormatList } = generalSettingReducer
  const { loginData, roleRights, showModal, modalType } = common
  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('')
  const [headText, setHeadText] = useState('')
  const [ticketFormatID, setTicketFormatID] = useState()
  const [branchListData, setBranchListData] = useState()
  const [editdata, setEditdata] = useState()
  const [isUpdate, setIsUpdate] = useState(false)
  const [filterValues, setFilterValues] = useState({})
  const [filteredData, setfilteredData] = useState(ticketFormatList)

  useEffect(() => {
    getTicketLabelList() //to get the labels list
    //get ticket formatlist
    const obj1 = {
      intTicketFormatID: 0,
      intCompanyID: loginData.intCompanyID,
      intIsDeleted: -1,
      // strFormatType: '',
    }
    getCargoTicketFormatList(obj1)
  }, [])
  const columnDefs = [
    {
      headerName: 'SN',
      headerSx: { padding: '6px 12px', textAlign: 'right', minWidth: '2%' },
      field: 'SN',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
    {
      headerName: 'Format ID',
      headerSx: { padding: '6px 12px', textAlign: 'right', minWidth: '5%' },
      field: 'TicketFormatID',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: 'Ticket Format Name',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '12%' },
      field: 'TicketFormatName',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },

    {
      headerName: 'Format Type',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '9%' },
      field: 'FormatType',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: 'Assign for Booking Print',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '9%' },
      field: 'Edit',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },

    {
      headerName: 'Assign for Sticker Print',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '9%' },
      field: 'Edit',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
    {
      headerName: 'Assign for Delivery Print',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '9%' },
      field: 'Edit',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
    {
      headerName: 'Status',
      headerSx: { padding: '6px 12px', textAlign: 'center', minWidth: '5%' },
      field: 'IsDeleted',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
    {
      headerName: 'Edit',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '4%' },
      field: 'Edit',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
  ]
  useEffect(() => setfilteredData(ticketFormatList), [ticketFormatList])
  useEffect(() => {
    const filteredDataTemp = ticketFormatList.filter((item) => {
      return columnDefs.every((column) => {
        const filterValue = filterValues[column.field] || ''
        const value = item[column.field]
        return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
      })
    })
    setfilteredData(filteredDataTemp)
  }, [filterValues])
  const handleChangeContain = (e, name) => {
    let value = e.target.value
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [name]: value,
    }))
  }
  const EmptyTableRow = () => {
    return (
      <TableRow>
        <TableCell colSpan={12}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '15px',
              marginBottom: '15px',
              color: 'red',
              fontSize: '14px',
            }}
          >
            <span>No results found for the selected filters.</span>
          </div>
        </TableCell>
      </TableRow>
    )
  }
  const handleCellClick = (actionType, TicketFormatID) => {
    let actionText = ''
    switch (actionType) {
      case 'Booking':
        actionText = 'Assign for Booking Print'
        break
      case 'Sticker':
        actionText = 'Assign for Sticker Print'
        break
      case 'Delivery':
        actionText = 'Assign for Delivery Print'
        break
      default:
        break
    }
    setHeadText(actionText)
    setTicketFormatID(TicketFormatID)
    updateModal(true, mdt.ticketFormat)
    //api call for branches list with ticket format
    const body = {
      intCompanyID: loginData?.intCompanyID,
      intBranchID: 0,
      Mode: actionType === 'Booking' ? 1 : actionType === 'Sticker' ? 2 : 3,
    }
    getBranchesWithCargoTicketFormat(body)
      .then((res) => {
        if (res.status === 'Success') {
          setBranchListData(res.Data.Table)
        } else {
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
        }
      })
      .catch((err) => {
        console.log('Error:', err)
      })
  }
  const handleEditClick = (item) => {
    // console.log(item)
    setEditdata(item)
    setIsUpdate(true)
    updateModal(true, mdt.ticketFormatCreate)
  }
  const InsideRowContent = (props) => {
    const { item, index } = props
    return (
      <TableRow key={`auto-trans-recv-${index}`} style={{ minHeight: '40px' }}>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '2%', padding: '4px 12px', textAlign: 'right' }}>
          {index + 1}
        </TableCell>

        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '5%', padding: '4px 12px', textAlign: 'right' }}>
          {item.TicketFormatID}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '9%', padding: '4px 12px' }}>
          {item.TicketFormatName}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '9%', padding: '4px 12px' }}>
          {item.FormatType}
        </TableCell>
        <TableCell
          onClick={() => handleCellClick('Booking', item.TicketFormatID)}
          style={{
            fontSize: '12px',
            minHeight: '40px',
            color: '#0086FF',
            width: '9%',
            padding: '4px 12px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          {/* {item.min} */}
          Select Branch To Assign
        </TableCell>
        <TableCell
          onClick={() => handleCellClick('Sticker', item.TicketFormatID)}
          style={{
            fontSize: '12px',
            minHeight: '40px',
            color: '#0086FF',
            width: '9%',
            padding: '4px 12px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          Select Branch To Assign
        </TableCell>
        <TableCell
          // onClick={() => {
          //   setHeadText('Assign for Delivery Print')
          //   updateModal(true, mdt.ticketFormat)
          // }}
          onClick={() => handleCellClick('Delivery', item.TicketFormatID)}
          style={{
            fontSize: '12px',
            minHeight: '40px',
            color: '#0086FF',
            width: '9%',
            padding: '4px 12px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          Select Branch To Assign
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '5%', padding: '4px 12px', textAlign: 'center' }}>
          {item.IsDeleted ? (
            <span>
              <XMarkSvg />
            </span>
          ) : (
            <span>
              <CheckMarkSvg />
            </span>
          )}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '4%', padding: '4px 12px' }}>
          <span
            id={`editBtn-${index}`}
            tabIndex={0}
            style={{
              display: 'flex',
              color: '#007bfd',
              fontSize: '13px',
              fontWeight: 'bold',
              width: '52px',
              padding: '2px 4px',
              marginLeft: '-6px',
            }}
            onClick={() => {
              handleEditClick(item)
            }}
          >
            <EditIcon sx={{ marginRight: '3px' }} />
            Edit
          </span>
        </TableCell>
      </TableRow>
    )
  }
  return (
    <>
      <Stack style={{ padding: '5px 0px' }}>
        <Button
          id="mopAddBtn"
          style={{ margin: '0', height: '40px', width: '150px' }}
          className="btn add-btn"
          variant="contained"
          color="error"
          // onClick={() => { handleAdd() }}
          // onKeyDown={(e) => {
          //     navigation1(e, `editBtn-0`, 'mopActive');
          // }}
          onClick={() => {
            setIsUpdate(false)
            updateModal(true, mdt.ticketFormatCreate)
          }}
        >
          create new
        </Button>
      </Stack>
      <Stack style={{ maxHeight: '60vh', marginTop: '7px' }}>
        <TableContainer
          className="lr-popup-table lrModel  scrollBlue"
          style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px' }}
          component={Paper}
        >
          <Table
            style={{ border: 'none', overflow: 'auto' }}
            stickyHeader
            id="focApprovalTbl"
            className="table1 table-Received "
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
              <TableRow key="foc-tbl-header" style={{ background: '#d9edff' }}>
                {columnDefs.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    style={{
                      ...col.headerSx,
                      verticalAlign: 'top',
                      backgroundColor: '#DAEDFE',
                      minHeight: '40px',
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444444',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      {col.headerName.split('\n').map((line, lineIndex) => (
                        <span key={`line-${lineIndex}`} style={{}}>
                          {line}
                        </span>
                      ))}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {columnDefs.map((col, index) =>
                  col.showfilter ? (
                    <TableCell key={`FTH-${index}`} style={{ padding: '6px 6px' }}>
                      <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                        <input
                          id={`index-${index}`}
                          className="field"
                          name="cancelSearchInput"
                          style={{ width: '100%', height: '24px' }}
                          placeholder="Contains"
                          onChange={(e) => handleChangeContain(e, col.field)}
                          // onKeyDown={(e) => keyboardNavigation(e, index === 1 ? `Edit-${showTableData?.length - 1}` : `index-${index - 1}`, index === 10 ? 'Edit-0' : `index-${index + 1}`)}
                        />
                        <FilterAltIcon style={{ color: '#aaa' }} />
                      </div>
                    </TableCell>
                  ) : (
                    <TableCell></TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            {filteredData?.length > 0 ? (
              <>
                <TableBody className="filter-data-row" style={{ border: 'none' }}>
                  {filteredData?.map((item, index) => (
                    <InsideRowContent item={item} index={index} key={index} />
                  ))}
                </TableBody>
              </>
            ) : (
              <>
                <TableBody>
                  <EmptyTableRow />
                </TableBody>
              </>
            )}
          </Table>
        </TableContainer>
      </Stack>
      {showModal && mdt.ticketFormat === modalType ? (
        <TicketFormatModal
          updateModal={updateModal}
          headTxt={headText}
          branchList={branchListData}
          AssignCargoTicketFormat={AssignCargoTicketFormat}
          loginData={loginData}
          mode={headText === 'Assign for Booking Print' ? 1 : headText === 'Assign for Sticker Print' ? 2 : 3}
          TicketFormatID={ticketFormatID}
        />
      ) : null}
      {showModal && mdt.ticketFormatCreate === modalType ? (
        <TicketFormatCreateModal
          updateModal={updateModal}
          headTxt={'Create New Format Design'}
          isUpdate={isUpdate}
          updateAlertError={updateAlertError}
          labelList={labelList}
          editData={editdata}
          updateTicketFormat={updateTicketFormat}
          loginData={loginData}
          getCargoTicketFormatList={getCargoTicketFormatList}
        />
      ) : null}
    </>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateModal,
  updateAlertError,
  getTicketLabelList,
  getBranchesWithCargoTicketFormat,
  getCargoTicketFormatList,
  AssignCargoTicketFormat,
  updateTicketFormat,
}
export default connect(mapStateToProps, mapDispatchToProps)(TicketFormat)
// export default TicketFormat
